module.exports = __webpack_public_path__ + "components/city-nav/static/award-afe263df5daabf040e35282d1cd8a673.svg";